import { render, staticRenderFns } from "../../../pages/physician/automatic-viewing/automatic-viewing.html?vue&type=template&id=7200b782&scoped=true&"
import script from "../../../pages/physician/automatic-viewing/automatic-viewing.js?vue&type=script&lang=js&"
export * from "../../../pages/physician/automatic-viewing/automatic-viewing.js?vue&type=script&lang=js&"
import style0 from "../../../pages/physician/automatic-viewing/automatic-viewing.css?vue&type=style&index=0&id=7200b782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200b782",
  null
  
)

export default component.exports